import React from "react";
import { HoverCard } from "../resultsPrimitives/hoverCardPrimitives.jsx";

export const warningMessages = messages => messages?.length
  ? <div className="grid gap-1 text-xs">{messages.map(message => <p key={message}>{message}</p>)}</div> : null;

const warningText = content => React.Children.toArray(content).map(node =>
  React.isValidElement(node) ? warningText(node.props.children) : String(node)).join("");

export default function FieldWarning({ title, content, warningKey, disabled, children }) {
  const signature = JSON.stringify([warningKey, warningText(content)]);
  const [acknowledged, setAcknowledged] = React.useState(null);
  const referenceRef = React.useRef(null), checkboxRef = React.useRef(null);
  React.useEffect(() => setAcknowledged(null), [signature]);
  const visible = Boolean(content) && acknowledged !== signature;
  const field = typeof children === "function" ? children(visible) : children;
  const focusAcknowledgement = event => {
    if (visible && ["Tab", "Enter"].includes(event.key) && !event.shiftKey && !event.altKey && !event.ctrlKey && !event.metaKey && !event.isComposing && checkboxRef.current) {
      event.preventDefault();
      checkboxRef.current.focus();
    }
  };
  return <HoverCard title={<span className="text-amber-800">{title}</span>} disabled={!visible} delay={80} placement="top"
    content={<div className="grid gap-1.5 rounded-[4px] bg-amber-50 p-2 text-amber-900">
      {content}
      <label className="inline-flex cursor-pointer items-start gap-1.5 border-t border-amber-200 pt-1.5 text-xs">
        <input ref={checkboxRef} type="checkbox" checked={false} className="mt-0.5 h-3.5 w-3.5 shrink-0 rounded-[4px] accent-accent focus-visible:outline-accent"
          onKeyDown={event => { if (event.key === "Tab" && event.shiftKey) { event.preventDefault(); referenceRef.current?.focus({ preventScroll: true }); } }}
          onChange={() => { setAcknowledged(signature); referenceRef.current?.focus({ preventScroll: true }); }} />
        <span>J’ai vérifié, masquer cet avertissement</span>
      </label>
    </div>}
    openOnTouch referenceAsChild interactive flat compactTitle maxWidth={360}
    accentColor="var(--hovercard-accent-warning)">
    {disabled ? <span ref={referenceRef} className="inline-block max-w-full rounded-[4px] focus-visible:outline-accent"
      tabIndex={visible ? 0 : undefined} aria-label={visible ? title : undefined} onKeyDown={focusAcknowledgement}>
      {field}
    </span> : React.cloneElement(field, { ref: referenceRef, onKeyDown: event => { field.props.onKeyDown?.(event); focusAcknowledgement(event); } })}
  </HoverCard>;
}
